import { render, staticRenderFns } from "./Publicity.vue?vue&type=template&id=3b05bb9a&scoped=true"
import script from "./Publicity.vue?vue&type=script&lang=js"
export * from "./Publicity.vue?vue&type=script&lang=js"
import style0 from "./Publicity.vue?vue&type=style&index=0&id=3b05bb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b05bb9a",
  null
  
)

export default component.exports